import { useLocation, useNavigate } from "react-router-dom";
import { Icon, type IconName } from "@blueprintjs/core";
import { useAuth } from "../lib/AuthContext";

interface NavItem {
  icon: IconName;
  label: string;
  path: string;
}

const mainNav: NavItem[] = [
  { icon: "dashboard", label: "Dashboard", path: "/dash" },
  { icon: "map-create", label: "Blueprints", path: "/blueprints" },
  { icon: "office", label: "Companies", path: "/leads" },
  { icon: "search-around", label: "People Search", path: "/people-search" },
];

const adminNav: NavItem[] = [
  { icon: "cog", label: "Settings", path: "/settings" },
];

export function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const isSuperadmin = user?.role === "superadmin";

  const initials = user
    ? user.full_name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "??";

  const renderItem = (item: NavItem) => {
    const isActive = location.pathname === item.path;
    return (
      <div
        key={item.path}
        className={`sidebar-item${isActive ? " active" : ""}`}
        onClick={() => navigate(item.path)}
      >
        <Icon icon={item.icon} size={16} />
        <span>{item.label}</span>
      </div>
    );
  };

  return (
    <nav className="app-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo" onClick={() => navigate("/dash")} style={{ cursor: "pointer" }}>
          <div className="sidebar-logo-icon">C</div>
          <span className="sidebar-logo-text">Criterion</span>
        </div>
      </div>

      <div className="sidebar-nav">
        <div className="sidebar-section-label">Main</div>
        {mainNav.map(renderItem)}

        {isSuperadmin && (
          <>
            <div className="sidebar-section-label">System</div>
            {adminNav.map(renderItem)}
          </>
        )}
      </div>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">{initials}</div>
          <div className="sidebar-user-info">
            <div className="sidebar-user-name">{user?.full_name ?? "User"}</div>
            <div className="sidebar-user-role">{user?.role === "superadmin" ? "Administrator" : "User"}</div>
          </div>
          <Icon
            icon="log-out"
            size={14}
            style={{ color: "#5c7080", cursor: "pointer", marginLeft: "auto" }}
            onClick={signOut}
          />
        </div>
      </div>
    </nav>
  );
}
